
/* ==========================================
   KEAN CART UPSELL
   Add product and refresh Emerge cart drawer
   without reloading the page
   ========================================== */

document.addEventListener('click', async function (event) {
  const button = event.target.closest(
    '.kean-cart-upsell__button'
  );

  if (!button || button.disabled) return;

  const upsell = button.closest('.kean-cart-upsell');
  const selector = upsell?.querySelector(
    '.kean-cart-upsell__variant'
  );

  const variantId = Number(
    selector?.value || button.dataset.variantId
  );

  if (!variantId) return;

  const originalText = button.textContent;

  button.disabled = true;
  button.textContent = 'ADDING...';

  let productAdded = false;

  try {
    const root = window.Shopify?.routes?.root || '/';

    /* 1. Add the selected product to Shopify */

    const response = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1
          }
        ]
      })
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(
        result.description || 'Could not add product'
      );
    }

    productAdded = true;
    button.textContent = 'ADDED ✓';

    /* 2. Find Emerge's existing cart component */

    const cartComponent = document.querySelector(
      '.drawer--instance[data-side="right"] ' +
      '.drawer--container[data-view="cart-drawer"] cart-root'
    );

    if (
      !cartComponent ||
      typeof cartComponent.updateHtml !== 'function'
    ) {
      throw new Error(
        'Product added, but cart refresh is unavailable.'
      );
    }

    /* 3. Refresh using Emerge's built-in method */

    await cartComponent.updateHtml();

    /* 4. Notify KEAN's free-shipping script */

    document.dispatchEvent(
      new CustomEvent('kean:cart-updated')
    );

    /* 5. Check that the cart drawer remains open */

    const drawer = cartComponent.closest(
      '.drawer--instance[data-side="right"]'
    );

    if (
      drawer &&
      drawer.getAttribute('aria-expanded') !== 'true'
    ) {
      console.warn(
        'KEAN: Cart drawer closed during refresh.'
      );
    }

  } catch (error) {
    console.error('KEAN cart upsell:', error);

    if (productAdded) {
      alert(
        'Your item was added, but the cart display ' +
        'could not update. Please close and reopen ' +
        'the cart to check your items.'
      );
    } else {
      alert(error.message);
    }

    if (button.isConnected) {
      button.disabled = false;
      button.textContent = originalText;
    }
  }
});
